import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useState } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import CandidatesList from 'components/CandidatesList'
import Candidate from 'Types/candidate.interface'
import Header from 'components/Header'

const defaultProperties: { [key: string]: string } = {
  module: 'candidats',
  tour: '2',
  titre: 'Notre boîte à questions pour la course au Conseil d’État',
  chapeau:
    'Treize politiciens et politiciennes en lice pour le Conseil d’État le 20 mars se sont soumis à la boîte à questions de la Tribune de Genève.',
  surtitre: '«C’est ou bien ou bien»',
  auteurs: 'Georges Cabrera, Mathieu Rudaz',
  video: 'https://server045.appuser.ch/447289h.mp4',
}

const MainComponent: FC<MicroFrontendProps> = ({
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  const [candidates, setCandidates] = useState<Candidate[]>([])
  const [lastUpdated, setLastUpdated] = useState<Date>(new Date())

  const modules: { [key: string]: ReactElement } = {
    header: (
      <Header
        title={properties.titre}
        text={properties.chapeau}
        sup={properties.surtitre}
        date={lastUpdated}
        video={properties.video}
        authors={properties.auteurs ? properties.auteurs.split(',') : []}
      />
    ),
    candidats: <CandidatesList candidates={candidates} />,
  }

  const theme = {
    backgroundColor: colorMode === 'dark' ? '#222222' : '#fff',
    grayColor: colorMode === 'dark' ? '#000000' : '#f5f6f7',
    blue: colorMode === 'dark' ? '#5a64a8' : '#202346',
    colorMode: colorMode,
  }

  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/wch-interactive/interaktiv-2023-candidats-conseil-etat-ge/candidats.json'
    )
      .then((response) => response.json())
      .then(({ data, updated }) => {
        const selectedCandidates =
          properties.tour === '2'
            ? data.filter(
                (d: Candidate) =>
                  ![
                    'barthassat',
                    'schneebeli',
                    'wuarin',
                    'frei',
                    'magnin',
                    'prezioso',
                  ].includes(d.id)
              )
            : data
        setCandidates(selectedCandidates.sort(() => 0.5 - Math.random()))
        setLastUpdated(new Date(updated))
      })
  }, [])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <ThemeProvider theme={theme}>
        {properties?.module && modules[properties.module]}
      </ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
